exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  opacity: 1;\n  transition: opacity .3s; }\n  .overlay.hidden {\n    opacity: 0; }\n\n.dialog-container {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: auto; }\n\n.dialog {\n  background: white;\n  box-shadow: 0 0 80px rgba(0, 0, 0, 0.4);\n  margin-top: 0;\n  transition: margin-top .3s ease; }\n  .dialog.hidden {\n    margin-top: 100%; }\n  .dialog .dialog-content {\n    padding: 1rem; }\n\n.col {\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 800px; }\n  @media (min-width: 801px) {\n    .col {\n      width: 800px; } }\n  @media (max-width: 800px) {\n    .col {\n      width: 100%; } }\n\n.spacer {\n  height: 200px; }\n\n.white {\n  background: white; }\n\n.title {\n  margin: 2rem 0 1rem;\n  font-size: 2rem; }\n  .title.first {\n    margin-top: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Thomas/Projekte/palettes/src/app/collection/containers/more-dialog/more-dialog.component.scss
// module id = ../../../../../src/app/collection/containers/more-dialog/more-dialog.component.scss
// module chunks = main